/*
 * **Le mode Analyse, le contrat entre le serveur et l'app** (chantier analyse-au-serveur,
 * modification 01) : ce que le serveur calcule (`server/src/domain/carte/analyse.ts`) et ce que
 * l'app en lit. Le serveur rend des faits (des nombres, des clés, des identifiants) ; l'écran
 * compose les mots (le nom d'un état, d'un mois, du groupe « sans »).
 *
 * Trois règles écrites une fois, que le serveur et l'app lisent : la lueur d'une date
 * (`lueurDeLaDate`, la frise la lit aussi), le contact d'une bulle (`contactDeLaBulle`, le
 * répertoire aussi) et la date d'une bulle (`dateDeLaBulle`, les infos des bulles aussi). Sans
 * dépendance : l'app les importe de l'entrée « . ».
 */
/** Les cinq états d'une bulle en Analyse, dans l'ordre du panneau. */
export const ETATS_D_ANALYSE = ['a_faire', 'monde', 'bloquee', 'acquise', 'reflexion'];
/** Les quatre regroupements, dans l'ordre où G les fait tourner. */
export const REGROUPEMENTS = ['etat', 'contact', 'lieu', 'mois'];
/**
 * Ce que dit une date à `dans` jours d'aujourd'hui : `proche` à 7 jours ou moins (une date passée
 * aussi, jamais « en retard »), `bientot` à 30 jours ou moins (en Analyse, la bulle luit), `null`
 * au-delà. La frise et l'Analyse la lisent ici.
 */
export function lueurDeLaDate(dans) {
    if (dans <= 7)
        return 'proche';
    return dans <= 30 ? 'bientot' : null;
}
/**
 * Le contact d'une bulle : son nom, son numéro, et la clé qui le reconnaît. Deux bulles qui portent
 * le même nom (ou, sans nom, le même numéro) sont le même contact. `null` : aucun. Le répertoire
 * et Regrouper par contact le lisent ici.
 */
export function contactDeLaBulle(b) {
    const nom = b.contactNom?.trim() || null;
    const numero = b.contactTel?.trim() || null;
    if (!nom && !numero)
        return null;
    return { cle: (nom ?? numero).toLocaleLowerCase('fr-FR'), nom, numero };
}
/**
 * **La date d'une bulle, la règle écrite une fois** : le rendez-vous d'abord, sinon l'échéance ;
 * `null`, aucune. `jourDUnInstant` lit le jour d'un rendez-vous là où vit l'utilisateur (le
 * serveur dans son fuseau, l'app dans celui du navigateur, qu'elle envoie au serveur).
 */
export function dateDeLaBulle(bulle, jourDUnInstant) {
    if (bulle.debut)
        return { sorte: 'rendez_vous', instant: bulle.debut, jour: jourDUnInstant(bulle.debut) };
    return bulle.dateEcheance ? { sorte: 'echeance', jour: bulle.dateEcheance } : null;
}
